$(document).on ('turbolinks:load', () => {
  // flatpickr
  // 日時フォーム 設定汎用関数
  // simple_formの場合 -> grid_wrapper_htmlでオプションのクラスを指定
  // それ以外の場合 -> input_groupに.form_datetimeを、その親要素にオプションのクラスを設定

  format = "Y/m/d H:i"
  enable_time = true

  $('.form_datetime').each((idx, elem) => {
    parent_class_list = elem.parentNode.classList

    step = 10
    if (parent_class_list.contains('stepping-20')) {
      step = 20
    } else if (parent_class_list.contains('stepping-30')) {
      step = 30
    } else if (parent_class_list.contains('stepping-1')) {
      step = 1
    }

    flatpickr(elem, {
      wrap: true,
      dateFormat: format,
      locale: 'ja',
      allowInput: true,
      enableTime: enable_time,
      minuteIncrement: step
    })
  })

  // 期間を指定するフォームの設定
  $(".date-from .form_datetime").each((idx, elem) => {
    elem._flatpickr.config.onChange.push((selected_dates) => {
      $('.date-to .form_datetime')[idx]._flatpickr.set('minDate', selected_dates[0])
    })
    $(".date-to .form_datetime")[idx]._flatpickr.config.onChange.push((selected_dates) => {
      elem._flatpickr.set('maxDate', selected_dates[0])
    })
  })

  // 日付フォーム 設定汎用関数
  // simple_formの場合 -> grid_wrapper_htmlでオプションのクラスを指定
  // それ以外の場合 -> input_groupに.form_dateを、その親要素にオプションのクラスを設定

  $('.form_date').each((idx, elem) => {
    parent_class_list = elem.parentNode.classList

    format = "Y/m/d"
    if (parent_class_list.contains('no-day')) {
      format = "Y/m"
    }

    flatpickr(elem, {
      wrap: true,
      dateFormat: format,
      locale: 'ja',
      allowInput: true,
      enableTime: false
    })
  })

  // 期間を指定するフォームの設定
  $(".date-from .form_date").each((idx, elem) => {
    elem._flatpickr.config.onChange.push((selected_dates) => {
      $('.date-to .form_date')[idx]._flatpickr.set('minDate', selected_dates[0])
    })
    $(".date-to .form_date")[idx]._flatpickr.config.onChange.push((selected_dates) => {
      elem._flatpickr.set('maxDate', selected_dates[0])
    })
  })
})
